import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPowerOff = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-power-off';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "m11.25 5.01.01 2.49h1.48l.01-2.49.011-2.49h-1.522zm-3.171-.319c-.97.488-1.599.949-2.34 1.714-.952.984-1.623 2.077-2.037 3.321A8.74 8.74 0 0 0 8.18 20.362a8.4 8.4 0 0 0 3.82.878c1.38 0 2.582-.276 3.82-.878a8.75 8.75 0 0 0 4.757-9.602c-.451-2.245-1.827-4.279-3.769-5.571-.437-.291-1.48-.813-1.527-.765-.019.02-.153.333-.298.696-.186.464-.249.665-.213.676.027.01.257.121.51.248 1.9.952 3.351 2.818 3.793 4.877.189.878.215 1.999.066 2.839a7.6 7.6 0 0 1-.965 2.52c-.883 1.441-2.274 2.555-3.848 3.081a7.1 7.1 0 0 1-4.652 0C7.6 18.668 5.9 16.986 5.159 14.893c-.45-1.273-.521-2.752-.198-4.129.464-1.977 1.911-3.794 3.759-4.72.253-.127.483-.238.511-.248.035-.011-.03-.217-.222-.693-.149-.373-.29-.683-.312-.691s-.3.118-.618.279"
    })
  }));
});
export default SvgPowerOff;